import React, { useRef, useState } from 'react'
import useAmplitude from '../../hooks/useAmplitude'
import useApi from '../../hooks/useApi'
import {
  VIDEO_INPUT_CHANGED,
  FREE_TRANSCRIPT_CLICKED,
  FREE_TRANSCRIPT_FINISHED,
  FREE_TRANSCRIPT_FAILED,
  EMAIL_INPUT_CHANGED,
} from '../../helpers/events'
import CTAButton from '../CTAButton'

export default function Transcript() {
  const [validForm, setValidForm] = useState(false)
  const trackedEmail = useRef()
  const trackedVideoUrl = useRef()
  const emailRef = useRef()
  const videoRef = useRef()
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const { logEvent } = useAmplitude()
  const { createFreeTranscript } = useApi()

  const getPayload = () => ({
    url: videoRef.current.value,
    email: emailRef.current.value,
  })

  const onVideoUrlChanged = () => {
    setError(false)
    setValidForm(videoRef.current.value && emailRef.current.value)

    if (!trackedVideoUrl.current) {
      return
    }
    trackedVideoUrl.current = true
    logEvent(VIDEO_INPUT_CHANGED, { source: 'transcript' })
  }

  const onFreeClick = async () => {
    if (
      !emailRef.current.reportValidity() ||
      !videoRef.current.reportValidity()
    ) {
      return
    }
    setLoading(true)
    logEvent(FREE_TRANSCRIPT_CLICKED, getPayload())

    try {
      await createFreeTranscript(getPayload())
      logEvent(FREE_TRANSCRIPT_FINISHED, getPayload())
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 3000)
    } catch (err) {
      setError(
        'Something went wrong. Plese check if this video has an auto generated transcript.',
      )
      logEvent(FREE_TRANSCRIPT_FAILED, getPayload())
    } finally {
      setLoading(false)
    }
  }

  const onEmailChanged = () => {
    setError(false)
    setValidForm(videoRef.current.value && emailRef.current.value)

    if (!trackedEmail.current) {
      return
    }
    trackedEmail.current = true
    logEvent(EMAIL_INPUT_CHANGED, { source: 'transcript' })
  }

  return (
    <div className="flex flex-col justify-center space-y-8">
      <div className="flex flex-col w-full px-8 py-12 mx-auto">
        <div className="flex flex-col items-center mb-4 lg:flex-row">
          <p className="flex-shrink-0 mb-2 mr-4 text-base font-medium text-left text-gray-400 rounded lg:mg-0 lg:text-2xl focus:ring-4 focus:ring-purple-500 focus:ring-opacity-50 focus:ring-offset-2 focus:outline-none">
            Get subtitles from:
          </p>
          <input
            required
            ref={videoRef}
            onChange={onVideoUrlChanged}
            type="text"
            className="flex-1 w-full px-5 py-3 text-sm placeholder-gray-600 border border-gray-300 rounded-full lg:text-2xl focus:ring-4 focus:border-purple-700 focus:ring-purple-500 focus:ring-opacity-50 focus:outline-none"
            placeholder="Enter Public Youtube Link"
          />
        </div>
        <div className="flex flex-col items-center mb-16 lg:flex-row">
          <p className="flex-shrink-0 mb-2 mr-4 text-base font-medium text-left text-gray-400 lg:mg-0 lg:text-2xl focus:ring-4 focus:ring-purple-500 focus:ring-opacity-50 focus:ring-offset-2 focus:outline-none">
            email them to me:
          </p>
          <input
            required
            ref={emailRef}
            onChange={onEmailChanged}
            type="email"
            autoComplete="email"
            className="flex-1 w-full px-5 py-3 text-sm placeholder-gray-600 border border-gray-300 rounded-full lg:text-2xl focus:ring-4 focus:border-purple-700 focus:ring-purple-500 focus:ring-opacity-50 focus:outline-none"
            placeholder="Enter Your E-Mail"
          />
        </div>
        {error && <p className="mb-2 text-center text-red-500">{error}</p>}
        <CTAButton
          onClick={onFreeClick}
          disabled={!validForm || loading}
          loading={loading}
          success={success}
          text="Download subtitles"
          className="flex-1 w-full px-5 py-3 text-sm placeholder-gray-600 border border-gray-300 rounded-full lg:text-2xl focus:ring-4 focus:border-purple-700 focus:ring-purple-500 focus:ring-opacity-50 focus:outline-none"
        />
        <p className="text-center text-gray-400">
          We&apos;ll send you an email with the subtitles once it finishes 😉
        </p>
      </div>
    </div>
  )
}
